import React from 'react'
import { getDocumentType } from '../../utils/search/getDocumentType'
import SearchPreviewQuestion from './preview/SearchPreviewQuestion'
import SearchPreviewSet from './preview/SearchPreviewSet'
import SearchPreviewPack from './preview/SearchPreviewPack'
import SearchPreviewFolder from './preview/SearchPreviewFolder'

// True when the suggestion is the type of hit that has a library entity to
// preview (set / question / pack / folder, or a recent-cache row that points
// at one of those). Used both here and by the dropdown shell to decide
// whether to render the preview column at all.
export function shouldShowPreviewFor(suggestion) {
  if (!suggestion) return false
  if (suggestion.__quickAction) return false
  if (suggestion.__helpShowMore) return false
  if (suggestion.__external) return false
  if (suggestion.__nav) return false
  if (suggestion.showMore) return false
  if (suggestion.__recent) {
    if (!suggestion.item) return false
    const itemType = suggestion.__recentItemType
    return itemType === 'set' || itemType === 'question'
  }
  return !!getDocumentType(suggestion)
}

// Routes the currently-highlighted suggestion to the right preview component.
// Used both inside the dropdown (sibling of the suggestions list) and on the
// results page right panel — passing the active hit as `suggestion`.
//
// Non-library hits render nothing, so the dropdown's preview column collapses
// and the results page right panel stays empty rather than showing a
// placeholder card.
function SearchPreviewPane({ suggestion }) {
  if (!shouldShowPreviewFor(suggestion)) return null

  if (suggestion.__recent) {
    const { item, __recentItemType: itemType } = suggestion
    if (itemType === 'set') {
      const setHit = {
        id: item.id,
        name: item.name,
        questions: item.questions,
        clientModified: item.clientModified,
      }
      return <SearchPreviewSet hit={setHit} />
    }
    if (itemType === 'question') {
      return <SearchPreviewQuestion hit={{ id: item.id, ...item }} />
    }
    return null
  }

  const itemType = getDocumentType(suggestion)
  if (itemType === 'question') return <SearchPreviewQuestion hit={suggestion} />
  if (itemType === 'set') return <SearchPreviewSet hit={suggestion} />
  if (itemType === 'repo') return <SearchPreviewPack hit={suggestion} />
  if (itemType === 'folder') return <SearchPreviewFolder hit={suggestion} />

  return null
}

export default SearchPreviewPane
